import { ORDER_RECEIPTS } from '../actionTypes';

export const fetchOrderReceipt = (action) => ({
  type: ORDER_RECEIPTS.FETCH,
  payload: action.payload,
});
